import './DataTableAllColumnsHiddenEmptyState.css';
export var emptyState = '_srhgvd0-3-12-1';